module.exports = "pegasus/assets/video-thumb.png";